"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _LinearProgress = require("@material-ui/core/LinearProgress");

var _LinearProgress2 = _interopRequireDefault(_LinearProgress);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function LinearSpinner(props) {
  return _react2.default.createElement("div", null);
}

exports.default = LinearSpinner;

// <LinearProgress variant="query" {...props}/>


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-framework/ui-atoms/LinearSpinner/index.js
// module id = ../lib/egov-ui-framework/ui-atoms/LinearSpinner/index.js
// module chunks = 504